import { render, staticRenderFns } from "./CopyStakeUserBlacklistView.vue?vue&type=template&id=4dff205c&scoped=true&lang=pug"
import script from "./CopyStakeUserBlacklistView.vue?vue&type=script&lang=ts"
export * from "./CopyStakeUserBlacklistView.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeUserBlacklistView.vue?vue&type=style&index=0&id=4dff205c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dff205c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VContainer,VIcon,VSelect,VTextField})
